export function formatUrl(url: string): string {
  if (url) {
    if (url.indexOf('https') === -1 || url.indexOf('http') === -1) {
      return `https://s3.amazonaws.com/attachments.fieldcontrol.com.br/${url}`;
    }

    return url;
  }
  return 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';
}
